import {LichenRecordField} from "@/config/config-lichen";

/**
 * Takes the complex config file used for user input and transforms it to simple key-value
 * object in such a way that it can be submitted to the server.
 * @param lichenRecordForm
 */

export const toUrlParams = function (lichenRecordForm: { site: LichenRecordField[], records: LichenRecordField[][] }) {
    const result = {} as any // Here goes the configless data
    result.records = lichenRecordForm.records.map(record => simplifyRecord(record)) // Funde
    Object.assign(result, simplifySite(lichenRecordForm.site)) // Fundort
    return result
}

function simplifySite(site: LichenRecordField[]) {
    const result = {} as any
    site.forEach((field: LichenRecordField) => result[field.name] = field.value)

    result.x = result.coords[0]
    result.y = result.coords[1]

    return result
}


function simplifyRecord(lichenRecord: LichenRecordField[]) {
    const result = {} as any
    lichenRecord.forEach((field: LichenRecordField) => result[field.name] = field.value)
    result.specimens = result.specimens.map((spec: LichenRecordField[]) => simplifySpecimen(spec))

    // special taxon handling for complex entities
    result.taxonReferenceSuggested = {
        'ifFlorAppReferenceWork': result.taxonReferenceSuggested.find((field: LichenRecordField) => field.name === 'ifFlorAppReferenceWork').value,
        'taxonId': result.taxonReferenceSuggested.find((field: LichenRecordField) => field.name === 'taxonId').value,
        'suggestedTaxonName': result.taxonReferenceSuggested.find((field: LichenRecordField) => field.name === 'suggestedTaxonName').value,
        'suggestedTaxonPublication': result.taxonReferenceSuggested.find((field: LichenRecordField) => field.name === 'suggestedTaxonPublication').value,
        // 'suggestedTaxonDescription': result.taxonReferenceSuggested.find((field: LichenRecordField) => field.name === 'suggestedTaxonDescription').value,
        'suggestedTaxonComment': result.taxonReferenceSuggested.find((field: LichenRecordField) => field.name === 'suggestedTaxonComment').value,
    }

    result.images = JSON.parse(JSON.stringify(result.images))

    return result
}


function simplifySpecimen(specimen: LichenRecordField[]) {
    let result = {} as any
    if (specimen.constructor.name == "Array") {
        // for new specimens that are populated using the config structure
        specimen.forEach((field: LichenRecordField) => result[field.name] = field.value)
    } else {
        result = specimen
    }
    return result
}


